import { Component } from '@angular/core';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {AuthenticationHelperService} from '../../../services/helpers/authentication-helper.service';

@Component({
  selector: 'app-company-subscription',
  templateUrl: './company-subscription.component.html',
})
export class CompanySubscriptionComponent {
  isShowCompanyPayment = false;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private authHelperService: AuthenticationHelperService ) {
  }

  logout(): void {
    this.authHelperService.clientLogout(PAGES_AND_PATHS.login.pagePath);
  }
}
